import { config } from '../config'
import {
  ERROR_RESPONSES,
  SUCCESS_RESPONSES,
} from '../constants/serverResponses'
import { DataDog } from '../datadog'

class APIFetcher {
  constructor({ headers, baseURL }) {
    this.headers = headers
    this.baseURL = baseURL
  }

  generateRequestUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID()
    }
      const fallbackUUID = `fallback-uuid-${  Math.random().toString(36).substring(2, 11)  }-${  Date.now()}`
      DataDog.warn('crypto.randomUUID is not available. Using fallback UUID.', {})
      return fallbackUUID

  }

  setToken(token) {
    this.headers.Authorization = `Bearer ${token}`
  }

  get(url) {
    return this.request(url, 'GET')
  }

  post(url, body) {
    return this.request(url, 'POST', body)
  }

  delete(url, body) {
    return this.request(url, 'DELETE', body)
  }

  getImage(url) {
    return this.getImageByUrl(url)
  }

  getImageByUrl(url) {
    DataDog.info(`Request send ${url}`, {
      method: 'GET',
      url: this.baseURL + url,
      headers: this.headers,
    })
    return fetch(this.baseURL + url, {
      method: 'GET',
      headers: this.headers,
    }).then(res =>
      res?.blob().then(img => {
        const reader = new FileReader()
        reader.readAsDataURL(img)
        return new Promise(resolve => {
          reader.onloadend = () => {
            resolve(reader.result)
          }
        })
      }),
    )
  }

  request(url, method, body) {
    const requestUUID = this.generateRequestUUID()
    DataDog.info(`Request send ${url}`, {
      method,
      url: this.baseURL + url,
      headers: {
        ...this.headers,
        'x-idempotency-key': requestUUID
      },
      body,
    })
    // for PCI component
    if (!this.headers?.Authorization && window.MFEToken) {
      this.headers.Authorization = `Bearer ${window.MFEToken}`
    }

    return fetch(this.baseURL + url, {
      method,
      headers: {
        ...this.headers,
        'x-idempotency-key': requestUUID
      },
      body: JSON.stringify(body),
    })
      .then(r => {
        if (r?.text) {
          // use r.text instead of r.json to prevent errors when we get empty body (for example OPP-3119)
          return r.text().then(text => {
            const removedSpacesResponse = text.replace(/\s/g, '')
            const data = removedSpacesResponse ? JSON.parse(text) : {}
            if (r.status === SUCCESS_RESPONSES.OK) {
              DataDog.info(`Success response received ${url}`, {
                statusCode: r.status,
                data,
              })
            } else if (
              r.status >= ERROR_RESPONSES.SERVER_ERROR ||
              r.status === ERROR_RESPONSES.NOT_FOUND_ERROR
            ) {
              DataDog.error(
                `Failure 5xx or 404 response status received ${url}`,
                {
                  statusCode: r.status,
                  data,
                },
              )
            } else {
              DataDog.warn(`Failure response received ${url}`, {
                statusCode: r.status,
                data,
              })
            }

            return {
              responseData: data,
              responseStatus: r.status,
            }
          })
        }

        if (
          r.status >= ERROR_RESPONSES.SERVER_ERROR ||
          r.status === ERROR_RESPONSES.NOT_FOUND_ERROR
        ) {
          DataDog.error(
            `Failure 5xx or 404 response without data received ${url}`,
            {
              statusCode: r.status,
            },
          )
        } else {
          DataDog.warn(`Failure response without data received ${url}`, {
            statusCode: r.status,
          })
        }
        return {
          responseData: null,
          responseStatus: r.status,
        }
      })
      .catch(e => console.error(e))
  }
}

export const API = new APIFetcher({
  headers: { 'Content-Type': 'application/json', cache: 'no-cache' },
  baseURL: config.apiEndpoint,
})
